<style scoped>
	#app {
		padding: 20px;
	}
	.header {
		line-height: 60px;
		font-size: 16px;
		font-weight: bold;
		
	}
	.table-box {
		margin-top: 10px;
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
	}
	
	.table-header {
		padding: 15px 20px;
		font-size: 14px;
		font-weight: bold;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
	.box {
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
		display: flex;
		flex-wrap: wrap;
		padding: 10px 0;
		font-size: 14px;
	}
	.form-item {
		height: 60px;
		width: 380px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.form-name {
		width: 120px;
		text-align: right;
	}
	.inp {
		width: 280px;
	}
	.el-button--primary {
		background-color: #1677FF!important;
	}
	.dot {
		color: #52C51A;
		padding: 10px;
	}
	.il {
		display: flex;
		flex-direction: row;
	}
	.t-box {
		border: solid 1px #dcdcdc;
		padding: 0 4px;
		border-radius: 4px;
	}
	.t-box1 {
		border: solid 1px #3da113;
		color: #3da113;
		padding: 0 4px;
		border-radius: 4px;
		background-color: #F7FFFE;
	}
	.t-edit {
		font-size: 14px;
		padding: 0 4px;
		margin-left: 10px;
		cursor: pointer;
	}
	.t-a {
		color: #1677FF;
		text-decoration: underline;
		cursor: pointer;
	}
	.tag-btn {
		cursor: pointer;
	}
	
</style>
<template>
	<div id="app">
		<div class="box">
			<div style="margin-left: 20px; display: flex; flex-direction: row; align-items: center;">
				<el-button size="small" type="success" @click="searchFunc()">刷新</el-button>
				<div style="margin-left: 30px;">
					先编辑配置通道信息后，<span class='g'>"审核开关"</span>和<span class='g'>"平台开关"</span><span class='r'>同时开启</span>后，店主端<span class='r'>才可开启</span><span class='g'>"店铺开关"</span>
				</div>
			</div>
		</div>
		
		<div class="table-box">
			<el-table :data="tableData" border 
				v-loading="loading"
				size="mini"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" >
			    <el-table-column prop="id" label="编号" align="center" width="80"></el-table-column>
				
				<el-table-column prop="types" label="类型" align="center">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.types == 1" size="small">线上</el-tag>
						<el-tag v-if="scope.row.types == 2" size="small" type="success">线下</el-tag>
					</template>
				</el-table-column>
				
				<el-table-column prop="pay_name" label="通道名称" align="center" >
				</el-table-column>
				
				<el-table-column prop="pay_code" label="通道编码" align="center" >
				</el-table-column>
				
				<el-table-column prop="shop_status" label="店铺开关" align="center">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.shop_status == 1" size="small">开启</el-tag>
						<el-tag v-if="scope.row.shop_status == 0" size="small" type="danger">关闭</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="pass_status" label="审核状态" align="center">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.pass_status == 1" size="small">开启</el-tag>
						<el-tag v-if="scope.row.pass_status == 0" size="small" type="danger">关闭</el-tag>
						<el-tag v-if="scope.row.pass_status == 99" size="small" type="info">停用</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="plat_status" label="平台开关" align="center">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.plat_status == 1" size="small">开启</el-tag>
						<el-tag v-if="scope.row.plat_status == 0" size="small" type="danger">关闭</el-tag>
					</template>
				</el-table-column>
				
				<el-table-column prop="status" label="操作" fixed="right" align="center">
					<template slot-scope="scope">
						<el-tag class='tag-btn' type="success" style="margin-right: 10px;" size="mini" @click="editPay(scope)">编辑</el-tag>
					</template>
				</el-table-column>
			  </el-table>
		</div>
		
		<el-dialog title="编辑" :visible.sync="editShow" append-to-body v-if="editShow" width="800px" :before-close="handleClose">
			<payEdit :id="editId"></payEdit>
		</el-dialog>
		
	</div> 
</template>

<script>
	
	import payEdit from './payEdit.vue';
	
	export default {
		components:{
			payEdit
		},
		props:['sid'],
		data(){
			return {
				actionSid:0,
				loading:false,
				tableData: [],
				editShow:false,
				editId:0,
			}
		},
		watch:{
			sid(_new, _old){
				if(_new != _old){
					this.currentPage = 1;
					this.getData();
				}
			}
		},
		created() {
			this.getData();
		},
		methods:{
			handleClose(){
				this.editShow = false;
			},
			editPay(scope){
				this.editId = scope.row.id;
				this.editShow = true;
			},
			searchFunc(){
				this.getData();
			},
			getData(){
				let that = this;
				that.loading = true;
				that.$api.post("/Shop/getShopPayment", {sid:that.sid}).then(res=>{
					that.loading = false;
					that.tableData = res.data.list;
				}).catch(res=>{
					that.loading = false;
				});
			}
		}
	}
</script>
<style scoped>
	.g {
		color: #3399ff;
	}
	.r {
		color: red;
	}
</style>
